import React from 'react'
import styles from './styles.module.css'
import cn from 'classnames'


const Switch = ({onClick, hint, ...props}) => {
  
  const classNames = cn(styles.switch, {[styles.withHint]: !!hint, [styles.active]: props.checked})
  
  return (
    <label className={classNames} data-hint={hint}>
      <input type="checkbox" {...props}/>
      <span className={styles.slider} onClick={onClick}/>
    </label>
  )
}

export default Switch